import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { EmpresaService } from '../../../services/empresa.service';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-eliminar',
  imports: [ReactiveFormsModule],
  templateUrl: './modal-eliminar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-eliminar.component.css',
})
export class ModalEliminarComponent {
  private empresaService = inject(EmpresaService);

  empresa = input.required<any>();
  modal = input.required<any>();

  deleteSuccess = output<void>();
  deleteError = output<string>();

  confirmDelete() {
    this.empresaService.deleteEmpresa(this.empresa().id).subscribe({
      next: () => {
        this.deleteSuccess.emit();
        this.modal().close();
      },
      error: (error) => {
        this.deleteError.emit(error.message || 'Error');
        this.modal().close();
      },
    });
  }
}
